<div class="image-border">
  @if (chatAvatar()) {
    <img class="image" [ngSrc]="chatAvatar()" [alt]="initials()" fill priority />
  } @else {
    <div
      class="initials"
      [style.background-color]="colorInfo()?.background"
      [style.color]="colorInfo()?.foreground"
    >
      {{ initials() }}
    </div>
  }
  @let statusToUse = status() | userStatus;
  @if (statusToUse) {
    <div class="status-indicator" [style.backgroundColor]="statusToUse"></div>
  }
</div>
